import { combineReducers } from "redux"

import {
  FormStepOneReducer,
  FormStepTwoReducer,
  FormStepThreeReducer
} from "./reducers/index";


const rootReducers = combineReducers({
  form: combineReducers({
    stepOne: FormStepOneReducer,
    stepTwo: FormStepTwoReducer,
    stepThree: FormStepThreeReducer,
  })
})


export default rootReducers;